import { NodeAccessProfileStatus } from '@prisma/client';
import { Tag, theme } from 'antd';

export type ProfileStatusRendererProps = {
  status?: NodeAccessProfileStatus | null;
};

export const ProfileStatusRenderer = ({ status }: ProfileStatusRendererProps) => {
  const { token } = theme.useToken();

  let color = '#8c8c8c';
  let label = 'Unknown';

  switch (status) {
    case NodeAccessProfileStatus.NEW:
      color = '#8c8c8c';
      label = 'New';
      break;
    case NodeAccessProfileStatus.PENDING:
      color = token.orange6;
      label = 'Pending';
      break;
    case NodeAccessProfileStatus.APPROVED:
      color = token.green7;
      label = 'Approved';
      break;
    case NodeAccessProfileStatus.DELETED:
      color = token.green3;
      label = 'Deleted';
      break;
    case NodeAccessProfileStatus.REJECTED:
      color = token.colorError;
      label = 'Rejected';
      break;
    case NodeAccessProfileStatus.CANCELLED:
      color = token.colorTextSecondary;
      label = 'Cancelled';
      break;
    default:
      break;
  }

  return <Tag color={color}>{label}</Tag>;
};
